/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  addBanks: (data) => {
    return axios.post(API_ENDPOINTS.ADD_Banks, data, {
      headers:{ isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },
  getbanksList: (params) => {
    return axios.get(API_ENDPOINTS.GET_BANKS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
      params,
    });
  },
  getBankDetailsbyId: (id) => {
    return axios.get(API_ENDPOINTS.GET_BANK_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },
  updateBank: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_BANK_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers:  { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },
 deleteBank: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_BANK_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },

    addBanksacc: (data) => {
    return axios.post(API_ENDPOINTS.ADD_Banks_ACC, data, {
      headers:{ isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },
  getbanksListacc: (params) => {
    return axios.get(API_ENDPOINTS.GET_BANKS_LIST_ACC, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
      params,
    });
  },
  getBankDetailsbyIdacc: (id) => {
    return axios.get(API_ENDPOINTS.GET_BANK_DETAILS_BY_ID_ACC + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },
  updateBankacc: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_BANK_DETAILS_BY_ID_ACC + "/" + id;
    return axios.put(url, data, {
      headers:  { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },
 deleteBankacc: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_BANK_DETAILS_BY_ID_ACC + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default"  },
    });
  },
};
